module.exports = __webpack_public_path__ + "static/img/gt.faa7294c.svg";